<template>
  <v-filter-modal
    class="calls-filters-mobile"
    :active-menu-item.sync="activeMenuItem"
    :menu="$options.NAME_MENU_ITEM"
    :count="filtersCount"
    @apply="applyFilters"
    @reset="resetFilters"
    @close="closeFilters"
  >
    <div v-if="!activeMenuItem" class="calls-filters-mobile__sorts">
      <div class="calls-filters-mobile__tabs-wrapper-title">СОРТИРОВАТЬ ПО</div>
      <div class="calls-filters-mobile__radio-wrapper" body-scroll-lock-ignore>
        <v-radio
          v-for="option in $options.SORT_OPTIONS"
          :key="option.label"
          v-model="filtersParams.orderBy"
          class="calls-filters-mobile__radio"
          :value="option.value"
          >{{ option.label }}</v-radio
        >
      </div>
    </div>

    <div class="calls-filters-mobile__menu">
      <v-menu v-if="!activeMenuItem" v-model="activeMenuItem">
        <v-menu-item name="category">
          Категория
          <span class="calls-filters-mobile__menu-item-preview"> {{ preview.category }} </span>
        </v-menu-item>
        <v-menu-item name="callSource">
          Источник лида
          <span class="calls-filters-mobile__menu-item-preview"> {{ preview.callSource }} </span>
        </v-menu-item>
        <v-menu-item name="price">
          Цена
          <span class="calls-filters-mobile__menu-item-preview"> {{ pricePreview }} </span>
        </v-menu-item>
        <v-menu-item v-if="isRoleAdmin" name="agent">
          Агент
          <span class="calls-filters-mobile__menu-item-preview">
            {{ preview.agent }}
          </span>
        </v-menu-item>
        <v-menu-item name="date">
          Дата лида
          <span class="calls-filters-mobile__menu-item-preview"> {{ datePreview }} </span>
        </v-menu-item>
        <v-menu-item name="call">
          Статус
          <span class="calls-filters-mobile__menu-item-preview"> {{ preview.callType }} </span>
        </v-menu-item>
      </v-menu>
    </div>

    <div v-if="!agentOptionsLoading" class="calls-filters-mobile__sections-wrapper">
      <div v-show="activeMenuItem === 'category'" class="calls-filters-mobile__select">
        <filters-select v-model="selectedCategory" :options="categoryOptions" class="calls-filters-mobile__list-item" />
      </div>
      <div v-show="activeMenuItem === 'agent'" class="calls-filters-mobile__select">
        <filters-select v-model="selectedAgent" :options="agentOptions" class="calls-filters-mobile__list-item" />
      </div>
      <div v-show="activeMenuItem === 'callSource'" class="calls-filters-mobile__select">
        <filters-select
          v-model="selectedCallSource"
          :options="callSourceOptions"
          class="calls-filters-mobile__list-item"
        />
      </div>
      <div v-show="activeMenuItem === 'call'" class="calls-filters-mobile__select">
        <filters-select
          v-model="selectedCallType"
          :options="callTypesOptions"
          class="calls-filters-mobile__list-item"
        />
      </div>

      <v-filter-price
        v-show="activeMenuItem === 'price'"
        :price-gte.sync="filtersParams.priceGte"
        :price-lte.sync="filtersParams.priceLte"
      />
      <v-date-publication
        v-show="activeMenuItem === 'date'"
        :date-from.sync="filtersParams.dateFrom"
        :date-to.sync="filtersParams.dateTo"
      />
    </div>
  </v-filter-modal>
</template>

<script>
import VFilterModal from '@/components/common/VFilterModal.vue'
import VMenu from '@/components/common/VMenu.vue'
import VMenuItem from '@/components/common/VMenuItem.vue'
import VRadio from '@/components/common/VRadio.vue'
import FiltersSelect from '@/components/Agent/AgentsSelect.vue'
import { advertsService, agentsService, ownersService } from '@/services/http'
import { SORT_OPTIONS_MAP } from '@/constants/callsOptions'
import { pluralizeNumeral } from '@/utils/pluralization'
import { formatDatePreview, formatMoney } from '@/utils/formatters'
import { mapGetters } from 'vuex'
import { MODULE_SESSION } from '@/store/modules/session/session.types'
import VDatePublication from '@/components/common/VDatePublication.vue'
import VFilterPrice from '@/components/common/VFilterPrice.vue'
import { CALLS_TYPES_OPTIONS } from '@/constants/callsStatuses'

function generateFilters() {
  return {
    categoryId: undefined,
    agentId: undefined,
    callSourceId: undefined,
    orderBy: '-call_date',
    dateTo: undefined,
    dateFrom: undefined,
    priceLte: undefined,
    priceGte: undefined,
    callType: undefined
  }
}

// TODO: зааменить на computed-свойства
function generatePreview() {
  return {
    agent: null,
    category: null,
    callSource: null,
    callType: null
  }
}

const NAME_MENU_ITEM_MAP = {
  agent: 'Агент',
  price: 'Цена',
  category: 'Категории',
  callSource: 'Источник лида',
  date: 'Дата лида',
  callType: 'Статус'
}

export default {
  SORT_OPTIONS: SORT_OPTIONS_MAP,
  NAME_MENU_ITEM: NAME_MENU_ITEM_MAP,
  CALLS_TYPES_OPTIONS,
  name: 'CallsFiltersMobile',
  components: {
    VFilterPrice,
    VDatePublication,
    VFilterModal,
    VRadio,
    VMenu,
    VMenuItem,
    FiltersSelect
  },
  props: {
    count: {
      type: Number,
      default: 0
    },
    defaultFilters: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data() {
    return {
      agentOptions: [],
      categoryOptions: [],
      callSourceOptions: [],
      activeMenuItem: undefined,
      agentOptionsLoading: false,
      categoryOptionsLoading: false,
      callSourceOptionsLoading: false,
      filtersParams: generateFilters(),
      preview: generatePreview()
    }
  },
  computed: {
    ...mapGetters({
      isRoleAdmin: `${MODULE_SESSION}/isRoleAdmin`
    }),
    selectedCategory: {
      get() {
        return { id: this.filtersParams.categoryId }
      },
      set(category) {
        this.filtersParams.categoryId = category?.id
        this.preview.category = category?.name
      }
    },
    selectedAgent: {
      get() {
        const a = this.agentOptions.find(agent => agent.profileId === this.filtersParams.agentId)?.id
        return { id: a }
      },
      set(agent) {
        this.filtersParams.agentId = agent?.profileId
        this.preview.agent = agent?.name
      }
    },
    selectedCallSource: {
      get() {
        return { id: this.filtersParams.callSourceId }
      },
      set(callSource) {
        this.filtersParams.callSourceId = callSource?.id
        this.preview.callSource = callSource?.name
      }
    },
    selectedCallType: {
      get() {
        return { id: this.filtersParams.callType }
      },
      set(callType) {
        this.filtersParams.callType = callType?.id
        this.preview.callType = callType?.name
      }
    },
    pricePreview() {
      if (this.filtersParams.priceGte || this.filtersParams.priceLte) {
        return `${formatMoney(this.filtersParams.priceGte) || '0'} - ${formatMoney(this.filtersParams.priceLte) ||
          '...'} ₽`
      }
      return null
    },
    datePreview() {
      return formatDatePreview(this.filtersParams.dateFrom, this.filtersParams.dateTo)
    },
    filtersCount() {
      const text = pluralizeNumeral(this.count, 'лид', 'лида', 'лидов')
      return `${this.count} ${text}`
    },
    callTypesOptions() {
      return CALLS_TYPES_OPTIONS.map(option => {
        return { id: option.value, name: option.label }
      })
    }
  },
  watch: {
    defaultFilters: {
      immediate: true,
      handler({ orderBy, status, page, ...newFilters }) {
        this.filtersParams = { ...this.filtersParams, ...newFilters }
      }
    },
    agentOptions() {
      this.preview.agent = this.agentOptions.find(agent => agent.profileId === this.filtersParams.agentId)?.name
    },
    categoryOptions() {
      this.preview.category = this.categoryOptions.find(category => category.id === this.filtersParams.categoryId)?.name
    },
    callSourceOptions() {
      this.preview.callSource = this.callSourceOptions.find(
        callSource => callSource.id === this.filtersParams.callSourceId
      )?.name
    }
  },
  created() {
    if (this.isRoleAdmin) {
      this.selectAgents()
    }
    this.selectCallSource()
    this.selectCategory()
    this.selectCallsType()
  },
  methods: {
    selectCallsType() {
      this.preview.callType = CALLS_TYPES_OPTIONS.find(
        callType => callType.value === this.filtersParams.callType
      )?.label
    },
    selectAgents() {
      this.agentOptionsLoading = true
      return agentsService
        .select()
        .then(agentList => {
          this.agentOptions = agentList
        })
        .finally(() => {
          this.agentOptionsLoading = false
        })
    },
    selectCategory() {
      this.categoryOptionsLoading = true
      return advertsService
        .selectCategory()
        .then(categories => {
          this.categoryOptions = categories
        })
        .finally(() => {
          this.categoryOptionsLoading = false
        })
    },
    selectCallSource() {
      this.callSourceOptionsLoading = true
      return ownersService
        .getCallSourcesMap()
        .then(callSources => {
          this.callSourceOptions = callSources
        })
        .finally(() => {
          this.callSourceOptionsLoading = false
        })
    },
    changeOrder(orderBy) {
      this.filtersParams.orderBy = orderBy
    },
    closeFilters() {
      this.$emit('close')
    },
    resetFilters() {
      this.filtersParams = generateFilters()
      this.preview = generatePreview()
    },
    applyFilters() {
      this.$emit('apply-filters', this.filtersParams)
    }
  }
}
</script>
